module.exports = __webpack_public_path__ + "img/img3.96241a28.png";